'use client'

import { Link } from '@mui/material'
import { styled } from '@mui/system'

import { colors } from '@/themes/commerce/colors'

export const StyledAnchor = styled(Link)(() => ({
  color: colors.text.link,
  textDecoration: 'none',
  textTransform: 'capitalize',
  fontSize: 14,
  '&:hover': {
    textDecoration: 'underline',
  },
}))
